import { render } from "./asset-form.vue?vue&type=template&id=67f52fce"
import script from "./asset-form.vue?vue&type=script&lang=js"
export * from "./asset-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__